import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import logo from "../images/StartPoint-logo.png";
import { Button, Checkbox, Form, Input, Carousel } from "antd";
import {
  EyeTwoTone,
  EyeInvisibleOutlined,
  UserOutlined,
  LockOutlined,
} from "@ant-design/icons";
import login3 from "../images/login-img/Mask_group_yo5vq9.png";
import swal from "sweetalert2";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { login } from "../actions/auth";

const Login = ({ login, isAuthenticated }) => {
  // remember
  useEffect(() => {
    const savedPhoneNumber = localStorage.getItem("savedPhoneNumber");
    const savedPassword = localStorage.getItem("savedPassword");

    if (savedPhoneNumber && savedPassword) {
      setFormData({
        phoneNumber: savedPhoneNumber,
        password: savedPassword,
        rememberMe: true,
      });
    }
  }, []);

  // new
  const [formData, setFormData] = useState({
    phoneNumber: "",
    password: "",
  });

  const { phoneNumber, password } = formData;

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
    if (type === "checkbox" && name === "rememberMe" && checked) {
      localStorage.setItem("savedPhoneNumber", formData.phoneNumber);
      localStorage.setItem("savedPassword", formData.password);
    } else {
      localStorage.removeItem("savedPhoneNumber");
      localStorage.removeItem("savedPassword");
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);
    login(phoneNumber, password);
  };

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  const contentStyle = {
    color: "#fff",
    lineHeight: "26px",
    textAlign: "center",
    fontSize: "20px",
    fontWeight: "500",
    padding: "3% 2%",
    height: "100px",
  };

  return (
    <section className="login-hero">
      <div className="login_wrapper">
        <div className="login__body">
          <div className="startpoint_desc">
            <div className="img-text">
              <Link to="/">
                <span className="img-logo">
                  <img src={logo} alt="Logo" />
                </span>
              </Link>
              <div className="login_text">
                <h3>
                  İdman zallarının onlayn abunəlik və zal idarəetmə sistemi
                </h3>
              </div>
            </div>
          </div>
          <div className="login_form">
            <div className="login_form_body">
              <Form onSubmit={onSubmit} method="post" name="complex-form">
                <Form.Item>
                  <label className="form_label">Telefon nömrəsi:</label>
                  <Input
                    name="phoneNumber"
                    type="text"
                    value={phoneNumber}
                    onChange={onChange}
                    prefix={<UserOutlined className="form_prefix-icon" />}
                  />
                </Form.Item>
                <Form.Item>
                  <label className="form_label">Şifrə:</label>
                  <Input.Password
                    type="password"
                    name="password"
                    value={password}
                    onChange={onChange}
                    prefix={<LockOutlined className="form_prefix-icon" />}
                    iconRender={(visible) =>
                      visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                    }
                  />
                </Form.Item>
                <Form.Item name="remember" valuePropName="checked">
                  <Checkbox
                    onChange={(e) => {
                      const checked = e.target.checked;
                      if (checked) {
                        localStorage.setItem("savedPhoneNumber", phoneNumber);
                        localStorage.setItem("savedPassword", password);
                      } else {
                        localStorage.removeItem("savedPhoneNumber");
                        localStorage.removeItem("savedPassword");
                      }
                    }}
                  >
                    <div className="remember_checkbox">Xatırla</div>
                  </Checkbox>
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="login-btn"
                    value="Login"
                    onClick={onSubmit}
                  >
                    Daxil ol
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
        <div className="login__carousel">
          <div className="carousel-img">
            <div className="carousel-box ">
              <img src={login3} alt="operator" />
            </div>
          </div>
          <div className="carousel-text">
            <Carousel autoplay>
              <div>
                <h3 style={contentStyle}>Abunəliklərin izlənilməsi</h3>
              </div>
              <div>
                <h3 style={contentStyle}>Gedişlərin izlənilməsi</h3>
              </div>
              <div>
                <h3 style={contentStyle}>Nağd və ya onlayn ödəniş</h3>
              </div>
            </Carousel>
          </div>
        </div>
      </div>
    </section>
  );
};

Login.propTypes = {
  login: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { login })(Login);
